import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "warning-span flex align-content-center justify-content-center p-3"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-exclamation-triangle",
    style: { "color": "var(--purple-500)", "font-size": "2rem", "margin-right": "10px" }
}, null, -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h5", null, "No user selected", -1);
const _hoisted_4 = [
    _hoisted_2,
    _hoisted_3
];
import { onBeforeMount, ref, watch } from "vue";
import UpdateUserClaims from "@/components/templates/BackOffice/forms/users/UpdateUserClaims.vue";
import AdminUserTable from "@/components/organisms/AdminUserTable.vue";
import AppConfigSideBar from "@/components/templates/Layout/AppConfigSideBar.vue";
import { AllActionTypes } from "@/store/action-types";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
import { useStore } from "@/shared/composables/useStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BackOfficeUsers',
    setup(__props) {
        const selectedUser = ref();
        const openAppConfig = ref(false);
        const contentChanged = ref(false);
        const store = useStore();
        onBeforeMount(async () => {
            await store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.BRANDS);
            await store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.MARKETS);
            await store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.WEBSITE);
        });
        watch(() => selectedUser.value, () => openAppConfig.value = !!selectedUser.value);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(AppConfigSideBar, {
                    simple: "",
                    title: "Manage user claims",
                    active: selectedUser.value !== undefined,
                    modelValue: openAppConfig.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((openAppConfig).value = $event))
                }, {
                    default: _withCtx(() => [
                        (selectedUser.value)
                            ? (_openBlock(), _createBlock(UpdateUserClaims, {
                                key: 0,
                                "user-data": selectedUser.value,
                                onUpdateRequiresReload: _cache[0] || (_cache[0] = ($event) => (contentChanged.value = true))
                            }, null, 8, ["user-data"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
                    ]),
                    _: 1
                }, 8, ["active", "modelValue"]),
                _createVNode(AdminUserTable, {
                    modelValue: selectedUser.value,
                    "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event) => ((selectedUser).value = $event)),
                        _cache[3] || (_cache[3] = ($event) => (openAppConfig.value = true))
                    ],
                    "reload-content": contentChanged.value,
                    onContentReloaded: _cache[4] || (_cache[4] = ($event) => (contentChanged.value = false))
                }, null, 8, ["modelValue", "reload-content"])
            ], 64));
        };
    }
});
